import { OAuth2Service } from '@creditornot/wolt-auth';

const origin = process.env.RELEASE_STAGE === 'local' ? 'http://localh:8889' : process.env.CDN_URL;

export const authService = new OAuth2Service({
  clientId: 'opstools',
  loginRedirectUri: `${origin}/oauth2/login-callback`,
  logoutRedirectUri: `${origin}/oauth2/logout-callback`,
  serviceUrl: process.env.AUTH_API_URI,
});
